import I18n from "../../I18n";

const mapCard = (json) => {
    const { name, username, role, blocked, organizationName, hasUpgradedAccount, lastSignInAt } = json;
    const upgradedAccount = hasUpgradedAccount ? hasUpgradedAccount.toString() : "false";
    const lastSignInDisplay = lastSignInAt
        ? new Date(lastSignInAt).toLocaleString()
        : I18n.translate("No login recorded");
    return [
        [{ labels: ["name"], value: name, type: "string", basis: "20%" }],
        [{ labels: ["username"], value: username, type: "string" }],
        [
            {
                labels: ["organizationName"],
                value: organizationName,
                type: "string",
                basis: "20%",
            },
        ],
        [
            {
                labels: ["role"],
                value: I18n.translate(`role_${role}`),
                type: "string",
            },
        ],
        [{ labels: ["Last Sign In"], value: lastSignInDisplay, type: "string" }],
        [{ labels: [], value: blocked, type: "user-status", basis: "10%" }],
        [
            {
                labels: ["hasUpgradedAccount"],
                value: {
                    label: I18n.translate(`account-verified-${upgradedAccount}`),
                    value: upgradedAccount,
                },
                type: "account-verified",

                basis: "10%",
            },
        ],
    ];
};

const mapper = (json, card, details) => {
    return {
        ...json,
        name: json.name,
        shortName: json.name,
        card: card ? mapCard(json) : [],
    };
};

const header = [
    { label: ["Full name"], align: "left", columnName: "name", sortable: true, basis: "20%" },
    { label: ["Username"], align: "left", columnName: "email", sortable: true },
    {
        label: ["Organization"],
        align: "left",
        columnName: "organizations.name",
        sortable: true,
        basis: "20%",
    },
    { label: ["Role"], align: "left", columnName: "role", sortable: true },
    { label: ["Last Sign In"], align: "left", columnName: "lastSignInAt" },
    { label: ["User Status"], align: "left", basis: "10%" },
    { label: ["Account Verified"], align: "left", columnName: "hasUpgradedAccount", basis: "10%" },
];

const userMapper = {
    map: mapper,
    header,
};

export default userMapper;
